if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.viewer = this.querySelector('[id^="GalleryViewer"]');
        this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        if (!this.viewer || !this.thumbnails) return;

        // Safari detection
        this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
                       /iPad|iPhone|iPod/.test(navigator.userAgent);

        // Initial fade-in for the active image
        let activeMedia = this.viewer.querySelector('.is-active img');
        let activeMediaItem = this.viewer.querySelector('.is-active');
        let activeThumbnail = this.thumbnails.querySelector('.is-active');
        if (!activeMediaItem) {
          // No active media, set the first as active
          activeMediaItem = this.viewer.querySelector('[data-media-id]');
          if (activeMediaItem) activeMediaItem.classList.add('is-active');
        }
        if (!activeThumbnail && activeMediaItem) {
          // Set corresponding thumbnail as active
          const mediaId = activeMediaItem.getAttribute('data-media-id');
          const thumb = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (thumb) thumb.classList.add('is-active');
          }
        activeMedia = activeMediaItem ? activeMediaItem.querySelector('img') : null;
        if (activeMedia) this.fadeInImage(activeMedia);

        // Fade-in for all thumbnail images
        this.thumbnails.querySelectorAll('.media-gallery__thumbnail > img').forEach(img => this.fadeInImage(img));

        // Thumbnail click handler
        this.thumbnails.querySelectorAll('[data-target]').forEach(thumbnail => {
          thumbnail.addEventListener('click', () => {
            const mediaId = thumbnail.dataset.target;
            const newMedia = this.viewer.querySelector(`[data-media-id="${mediaId}"]`);
            if (!newMedia) return;
            
            // Deactivate all
            this.viewer.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
            this.thumbnails.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
            
            // Pause/reset any active video or deferred-media
            this.viewer.querySelectorAll('.media-gallery__item').forEach(item => {
              // Pause <video>
              const video = item.querySelector('video');
              if (video && !video.paused) {
                video.pause();
              }
              
              // Reset deferred-media (remove iframe if present)
              const deferred = item.querySelector('deferred-media');
              if (deferred) {
                const iframe = deferred.querySelector('iframe');
                if (iframe) iframe.remove();
                // Re-show poster if hidden
                const poster = deferred.querySelector('.deferred-media__poster');
                if (poster) poster.classList.remove('hidden');
              }
            });
            
            // Activate new
            newMedia.classList.add('is-active');
            thumbnail.classList.add('is-active');
            
            // Fade in new image or handle video/deferred-media
            const img = newMedia.querySelector('img');
            const deferredMedia = newMedia.querySelector('deferred-media');
            const video = newMedia.querySelector('video');

            if (deferredMedia) {
              // The deferred-media component will handle the loading when user clicks
            } else if (video) {
              video.addEventListener('loadeddata', () => {
                video.classList.add('loaded');
              }, { once: true });
            } else if (img) {
              this.fadeInImage(img);
            }
          });
        });
      }

      fadeInImage(img) {
        img.classList.remove('loaded');
        if (img.complete && img.naturalWidth !== 0) {
          requestAnimationFrame(() => img.classList.add('loaded'));
        } else {
          img.addEventListener('load', () => img.classList.add('loaded'), { once: true });
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function() {
  // Safari detection
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
                   /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Initialize deferred-media elements for Safari
  if (isSafari) {
    document.querySelectorAll('.deferred-media').forEach(deferred => {
      // Ensure proper positioning for Safari
      deferred.style.position = 'relative';
      deferred.style.width = '100%';
      deferred.style.height = '100%';
    });
  }
});
